import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';

import ProfileLink from 'components/ProfileLink';
import ProfileAvatar from 'components/ProfileAvatar';

import VirtualGiftActions from 'components/virtualgift/VirtualGiftActions';

import {t} from 'l10n';
import {formatDate} from 'utils/virtualGifts';

import 'sass/modals/ModalViewVirtualGift.scss';

class ModalViewVirtualGift extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showAttachment: false
        };

        this.closeWrapper = this.closeWrapper.bind(this);
    }

    closeWrapper() {
        this.setState({showAttachment: false});
        this.props.closeFn();
    }

    render() {
        let {show, virtualGift} = this.props;

        let {showAttachment} = this.state;

        if (!show) return null;

        let imageUrl = virtualGift.image_url;
        if (showAttachment && virtualGift.attachment) {
            imageUrl = virtualGift.attachment.full_url;
        }

        return (
            <Modal className="modalViewVirtualGift" show={show} onHide={this.closeWrapper}>
                <Modal.Body>
                    <div className="close" onClick={this.closeWrapper}></div>

                    <div className={'virtual-gift' + (virtualGift.hidden ? ' hidden' : '')}>
                        <div className="img">
                            {virtualGift.attachment &&
                                <div className="toggleAttachment">
                                    <a onClick={() => this.setState({showAttachment: !showAttachment})}>
                                        {showAttachment ? t('Show the gift') : t('Show attached photo')}
                                    </a>
                                </div>
                            }
                            <VirtualGiftActions virtualGift={virtualGift} className="virtual-gift-actions"/>
                            <img src={imageUrl} alt=""/>
                        </div>
                        <div className="text">
                            <div className="author-details">
                                <ProfileAvatar user={virtualGift.sender}/>
                                <div className="details">
                                    <div className="author">{virtualGift.sender ? <ProfileLink user={virtualGift.sender} showRank/> : t('an anonymous')}</div>
                                    <div className="date">{formatDate(virtualGift, true)}</div>
                                </div>
                            </div>
                            <div className="message">
                                {virtualGift.comment}
                            </div>
                        </div>

                    </div>


                </Modal.Body>
            </Modal>
        )
    }
}

export default ModalViewVirtualGift;


// WEBPACK FOOTER //
// ./src/components/modals/ModalViewVirtualGift.js